const VideoBlockIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path fill="#ffd400" d="M1 1h22v22H1z" />
    <path d="M22 2v20H2V2h20m2-2H0v24h24V0z" fill="#333" />
    <path
      fill="#333"
      d="M15.576 11.807l-2.788 1.904L10 15.614V8l2.788 1.904 2.788 1.903z"
    />
  </svg>
);

export default VideoBlockIcon;
